/**
 * EIPlaceholder — Phase 2 sub-routes that aren't built yet show this card so
 * the navigation is complete and consistent with the rest of the app.
 */

import { Sparkles, Clock } from "lucide-react";

export default function EIPlaceholder({ title, blurb, Icon }) {
  return (
    <div className="ei-empty" data-testid="ei-placeholder">
      <span className="ei-empty-icon" style={{ background: "linear-gradient(135deg, #fef3c7, #fde68a)", color: "#92400e" }}>
        {Icon ? <Icon size={28} /> : <Sparkles size={28} />}
      </span>
      <h3>{title}</h3>
      <p>{blurb}</p>
      <p style={{
        marginTop: 18,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        background: "rgba(245, 158, 11, 0.12)",
        color: "#92400e",
        padding: "6px 14px",
        borderRadius: 999,
        fontSize: 11.5,
        fontWeight: 800,
        letterSpacing: 0.6,
        textTransform: "uppercase",
      }}>
        <Clock size={11} /> Coming next
      </p>
    </div>
  );
}
